import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlNorthIpswichPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["north-ipswich"]} />;
}
